export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14515.f4b3eee7.jpg";